import { useMember } from "../../context/memberContext";
import { useTranslations } from "../../hooks/useTranslations";
import Page from "../ui/Page";

const UniUrg = () => {
  const { i18n } = useTranslations();
  const { member } = useMember();

  if (!member) {
    return null;
  }

  const uniurgUrl = "https://arbeit.provinz.bz.it/de/uniurg";

  return (
    <Page
      title={i18n.uniUrg.title}
      backLinkText={i18n.payrollBackLink}
      narrow={true}
    >
      <div>
        <p>{i18n.uniUrg.paragraph1}</p>
        <p>{i18n.uniUrg.paragraph2}</p>
        <p>{i18n.uniUrg.paragraph3}</p>
        <ul>
          <li>{i18n.uniUrg.option1}</li>
          <li>{i18n.uniUrg.option2(<a href={uniurgUrl}>{uniurgUrl}</a>)}</li>
        </ul>
        <p>{i18n.uniUrg.paragraph4}</p>
        <p>
          {i18n.uniUrg.paragraph5(
            <a href="mailto:notel@provinz.bz.it">notel@provinz.bz.it</a>,
          )}
        </p>
      </div>
    </Page>
  );
};

export default UniUrg;
